module.exports = __webpack_public_path__ + "img/contract-logo.e1c864b3.png";